module.exports = {
  schema: {
    name: '標籤',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '標籤編號',
        unique: true,
      },
      name: {
        type: 'String',
        name: '標籤',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'name', width: 130 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '標籤',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/tags.js